var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i18n-router-link',{attrs:{"to":"/login"}},[_c('span',[_vm._v(_vm._s(_vm.$t("header.auth.login"))+_vm._s(_vm.$t("common.slash")))]),_c('span',[_vm._v(_vm._s(_vm.$t("header.auth.register")))])])}
var staticRenderFns = []

export { render, staticRenderFns }